import React from "react";
import { CITIES } from "../mock";

// Crisp, resolution-independent recreation of the Kapatia logo lockup
export default function BrandLockup({
  nameSize = "text-[23px] md:text-[26px]",
  hindiSize = "text-[24px] md:text-[27px]",
  citySize = "text-[10.5px] md:text-[11.5px]",
  nameColor = "var(--green-900)",
}) {
  return (
    <span className="brand-lockup grid leading-none">
      <span className="grid w-max justify-self-start">
        <span className={`font-heading ${nameSize} font-extrabold tracking-tight text-left`} style={{ color: nameColor, textShadow: "0 1px 0 rgba(0,0,0,0.10)" }}>
          Kapat<span className="kp-idot">i</span>a Pvt Ltd.
        </span>
        <span className="mt-[2px] h-[2px] w-full rounded" style={{ background: "var(--orange-600)", boxShadow: "0 1px 3px rgba(230,81,22,0.35)" }} />
      </span>
      <span className={`font-hindi mt-[8px] ${hindiSize} font-bold text-left`} style={{ color: "var(--yellow-500)", textShadow: "0 1px 1px rgba(0,0,0,0.12)" }}>
        कपाटिया
      </span>
      <span className={`mt-[8px] font-heading ${citySize} font-bold tracking-wide text-left`} style={{ color: nameColor }}>
        {CITIES.map((c, i) => (
          <React.Fragment key={c}>
            {i > 0 && <span className="mx-1" style={{ color: "var(--yellow-500)" }}>|</span>}
            {c}
          </React.Fragment>
        ))}
      </span>
    </span>
  );
}
